/** Cuts `str` to `length` characters in total, the last three being "...". */
export const truncate = (str: string | null, length: number) => {
  if (!str || str.length <= length) return str;
  return `${str.slice(0, length - 3)}...`;
};
